/*
 * PEWNA header — sticky scroll-state + mobile menu toggle.
 * Custom element <pewna-header> defined inline. No framework, no dependencies.
 */
class PewnaHeader extends HTMLElement {
  constructor() {
    super();
    this.scrollThreshold = Number(this.dataset.scrollThreshold) || 40;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleMenuToggle = this.handleMenuToggle.bind(this);
    this.handleEscape = this.handleEscape.bind(this);

    this.hamburger = this.querySelector('[data-hamburger]');
    this.mobileMenu = this.querySelector('[data-mobile-menu]');
    this.iconOpen = this.querySelector('[data-icon-open]');
    this.iconClose = this.querySelector('[data-icon-close]');
  }

  connectedCallback() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    document.addEventListener('keydown', this.handleEscape);

    if (this.hamburger) {
      this.hamburger.addEventListener('click', this.handleMenuToggle);
    }

    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('keydown', this.handleEscape);
    if (this.hamburger) {
      this.hamburger.removeEventListener('click', this.handleMenuToggle);
    }
  }

  handleScroll() {
    const shouldBeScrolled = window.scrollY > this.scrollThreshold;
    this.classList.toggle('pewna-header--scrolled', shouldBeScrolled);
  }

  handleMenuToggle() {
    const isOpen = !this.classList.contains('pewna-header--menu-open');
    this.setMenuState(isOpen);
  }

  handleEscape(event) {
    if (event.key === 'Escape' && this.classList.contains('pewna-header--menu-open')) {
      this.setMenuState(false);
    }
  }

  setMenuState(isOpen) {
    this.classList.toggle('pewna-header--menu-open', isOpen);
    document.body.classList.toggle('pewna-menu-open', isOpen);

    if (this.hamburger) {
      this.hamburger.setAttribute('aria-expanded', String(isOpen));
    }
    if (this.mobileMenu) {
      this.mobileMenu.hidden = !isOpen;
    }
    if (this.iconOpen && this.iconClose) {
      this.iconOpen.hidden = isOpen;
      this.iconClose.hidden = !isOpen;
    }
  }
}

customElements.define('pewna-header', PewnaHeader);
